import { useQuery } from "@-/com.npmjs.tanstack__react-query";
import type { HanziScript } from "@-/dev.improve.haniverse.lib.actor.types";
import { useActorUser } from "@-/dev.improve.haniverse.lib.user";
import { convertCharacter } from "#hanzi-script-converters";
import { getHanziScriptConvertersQueryOptions } from "#hanzi-script-converters-query-options";

/**
 * Returns `character` converted from `fromScript` into `toScript`, defaulting to the user's
 * selected `hanziScript`. While `opencc-js` is loading, the original `character` is returned.
 */
export function useConvertedCharacter(
  character: string,
  fromScript: HanziScript,
  toScript?: HanziScript,
): string {
  const { hanziScript } = useActorUser();
  const targetScript = toScript ?? hanziScript;
  const needsConversion = fromScript !== targetScript;
  const convertersQueryOptions = getHanziScriptConvertersQueryOptions();
  const { data: converters } = useQuery({
    ...convertersQueryOptions,
    enabled: needsConversion,
  });

  if (!needsConversion) {
    return character;
  }
  if (converters === undefined) {
    return character;
  }
  return convertCharacter(character, fromScript, targetScript, converters);
}
